/* RESPONSIBLE TEAM: team-automation-foundations */
import ConditionalBranches from 'embercom/models/operator/visual-builder/step/conditional-branches';
import type Store from '@ember-data/store';

export default class ResolutionRules extends ConditionalBranches {
  static createNewStep(store: Store): ResolutionRules {
    let predicateGroup = store.createFragment('predicates/predicate-group');

    let resolutionLimitPredicate = store.createFragment('predicates/boolean', {
      attribute: 'ai_agent.limit_reached',
      type: 'boolean',
      comparison: 'true',
      value: null,
    });

    predicateGroup.predicates.pushObject(resolutionLimitPredicate);

    let condition = store.createRecord('operator/visual-builder/connection-point', {
      label: null,
      type: 'conditional_branch',
      predicateGroup,
    });

    let elseBranch = store.createRecord('operator/visual-builder/connection-point', {
      label: null,
      type: null,
    });

    return store.createRecord('operator/visual-builder/step/resolution-rules', {
      outwardConnectionPoints: [condition, elseBranch],
      type: 'operator/visual-builder/step/resolution-rules',
    });
  }
}
